import { render, staticRenderFns } from "./Reason.vue?vue&type=template&id=99098996"
import script from "./Reason.vue?vue&type=script&lang=js"
export * from "./Reason.vue?vue&type=script&lang=js"
import style0 from "./Reason.vue?vue&type=style&index=0&id=99098996&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports